var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center pa-10"},[_c('h1',{staticClass:"text-h4 mb-4"},[_vm._v("404 - Page Not Found")]),_vm._v(" "),_c('p',[_vm._v("This page doesn't exist.")])])
}]

export { render, staticRenderFns }